module.exports = __webpack_public_path__ + "img/微信图片_20251028123229_207_595.b3ac46c4.jpg";